import { error99, RetAPI, SubGrupo } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid';
import { encode as base64_encode } from 'base-64'

export const SubGrupoService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Sgrupo/attributes', 'get', { id })
        const attributes: SubGrupo = {
            id: 0,
            description: '',
            id_user_insert: 0,
            id_user_last_update: 0,
            id_user_exclusao: 0,
            dt_cadastro: '',
            dt_last_update: '',
            dh_exclusao: '',
            name_user_insert: '',
            name_user_last_update: '',
            name_user_delete: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.sgrupo) {

                    attributes.id = resp.data.sgrupo.id
                    attributes.description = resp.data.sgrupo.descricao

                    attributes.id_user_insert = resp.data.sgrupo.id_user_insert
                    attributes.id_user_last_update = resp.data.sgrupo.id_user_last_update
                    attributes.id_user_exclusao = resp.data.sgrupo.id_user_exclusao

                    attributes.dt_cadastro = resp.data.sgrupo.dt_cadastro
                    attributes.dt_last_update = resp.data.sgrupo.dt_last_update
                    attributes.dh_exclusao = resp.data.sgrupo.dh_exclusao

                    attributes.name_user_insert = resp.data.sgrupo.name_user_insert
                    attributes.name_user_last_update = resp.data.sgrupo.name_user_last_update
                    attributes.name_user_delete = resp.data.sgrupo.name_user_delete

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (subGrupo: any): Promise<RetAPI> => {

        let id = ''

        if (subGrupo.id) {
            id = subGrupo.id.toString()
        }

        const resp = await Api('Sgrupo/save', 'post', {

            descricao: subGrupo.description, id
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados do subgrupo gravados com sucesso',
                id: resp.data.sgrupo.id,
                data: resp.data,
                dt_cadastro: resp.data.sgrupo.dt_cadastro,
                dt_last_update: resp.data.sgrupo.dt_last_update,
                name_user_insert: resp.data.sgrupo.name_user_insert,
                name_user_last_update: resp.data.sgrupo.name_user_last_update
            }
        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Sgrupo/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Sgrupo/filter', 'get', { field, filter_type, filter, id })
        const subGrupo: SubGrupo[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: subGrupo
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.sgrupos.map((item: any) => {
                    return subGrupo.push({

                        id: item.id,
                        description: item.descricao,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: subGrupo
            }
        }

        return { 
            error: false,
            data: subGrupo
        }

    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('Sgrupo/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const subGrupo: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: subGrupo
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.sub_grupos.map((item: any) => {
                    return subGrupo.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao

                    })
                })   
            }

        }else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: subGrupo
            }
        }

        return {
            error: false,
            data: subGrupo,
        }

    }
}
